import { Modal, Empty } from "antd";
import { useContext } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import { DocumentosModal } from "../../admin/casos/DocumentosModal";

export const ModalDocumentosTitular = () => {
    const { casos, documentos } = useContext(EditableContext);

    return (
        <DocumentosModal />
    );

}